import { QRCodeSVG } from "qrcode.react";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Download, Maximize2 } from "lucide-react";
import { useState } from "react";

interface Props {
  open: boolean;
  onClose: () => void;
  eventId: string;
  eventName: string;
}

export default function QRCodeDialog({ open, onClose, eventId, eventName }: Props) {
  const [fullscreen, setFullscreen] = useState(false);
  const checkinUrl = `${window.location.origin}/checkin?event_id=${eventId}`;

  const downloadQR = () => {
    const svg = document.getElementById("event-qr-svg");
    if (!svg) return;
    const svgData = new XMLSerializer().serializeToString(svg);
    const canvas = document.createElement("canvas");
    canvas.width = 800;
    canvas.height = 800;
    const ctx = canvas.getContext("2d");
    const img = new Image();
    img.onload = () => {
      ctx!.fillStyle = "#ffffff";
      ctx!.fillRect(0, 0, 800, 800);
      ctx!.drawImage(img, 100, 100, 600, 600);
      const a = document.createElement("a");
      a.download = `qr-${eventName.replace(/\s+/g, "-").toLowerCase()}.png`;
      a.href = canvas.toDataURL("image/png");
      a.click();
    };
    img.src = "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(svgData)));
  };

  if (fullscreen) {
    return (
      <div
        className="fixed inset-0 z-[100] bg-white flex flex-col items-center justify-center cursor-pointer"
        onClick={() => setFullscreen(false)}
      >
        <h2 className="text-3xl font-heading font-bold text-gray-900 mb-2">{eventName}</h2>
        <p className="text-lg text-gray-500 mb-8">Scan to check in</p>
        <QRCodeSVG value={checkinUrl} size={400} level="H" />
        <p className="mt-8 text-sm text-gray-400">Tap anywhere to exit fullscreen</p>
      </div>
    );
  }

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-sm text-center">
        <DialogHeader>
          <DialogTitle className="font-heading">{eventName}</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-muted-foreground mb-4">
          Scan this QR code to check in
        </p>
        <div className="flex justify-center">
          <QRCodeSVG id="event-qr-svg" value={checkinUrl} size={240} level="H" />
        </div>
        <p className="text-xs text-muted-foreground mt-3 break-all">{checkinUrl}</p>
        <div className="flex justify-center gap-3 pt-3">
          <Button variant="outline" size="sm" onClick={downloadQR}>
            <Download className="w-4 h-4 mr-1" /> Download
          </Button>
          <Button variant="outline" size="sm" onClick={() => setFullscreen(true)}>
            <Maximize2 className="w-4 h-4 mr-1" /> Fullscreen
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
